import { Table, type FormInstance } from 'antd';
import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import type { MaxLessonsPerDay, MaxLessonsPerDayConfigurationItem } from 'shared/api';
import { useMaxLessonsPerDayForm } from '../model';
import styles from './styles.module.scss';

interface MaxLessonsPerDayFormProps {
  form: FormInstance<MaxLessonsPerDay>;
  readOnly?: boolean;
  hideTitle?: boolean;
}

export const MaxLessonsPerDayForm = ({ form, readOnly, hideTitle }: MaxLessonsPerDayFormProps) => {
  const {
    state: { parameters, columns },
  } = useMaxLessonsPerDayForm(form, readOnly);

  return (
    <AppForm form={form} disabled={readOnly} className={styles.form}>
      {!hideTitle && (
        <AppFormItem name="name" label="Название" rules={formRules.required}>
          <AppInput placeholder="Введите название" />
        </AppFormItem>
      )}

      <AppFormItem
        name="parameters"
        rules={[
          {
            validator: (_, value: MaxLessonsPerDayConfigurationItem[]) => {
              if (!value?.length) {
                return Promise.reject(new Error('Заполните значения для всех параллелей'));
              }

              for (const item of value) {
                if (item.maxLessonsPerDay == null || item.maxLessonsPerDay < 1) {
                  return Promise.reject(
                    new Error('Максимум уроков в день должен быть не меньше 1'),
                  );
                }
                if (item.maxLessonsPerDay > 8) {
                  return Promise.reject(
                    new Error('Максимум уроков в день должен быть не больше 8'),
                  );
                }
              }

              return Promise.resolve();
            },
          },
        ]}
      >
        <AppInput type="hidden" />
      </AppFormItem>

      <Table
        columns={columns}
        dataSource={parameters}
        pagination={false}
        rowKey="parallel"
        bordered
      />
    </AppForm>
  );
};
